import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import "../../assets/css/authentification/forgot-password.css";
import LoaderAuth from "../../components/loader/authentification/LoaderAuth";
import AuthServices from "../../services/Auth.services";


const ForgotPassword = ({ setAlert }) => {
    const navigate = useNavigate();
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { verifyCaptchaV3, isLoading, setIsLoading } = useContext(AuthContext);

    const [email, setEmail] = useState("");

    const handleSubmit = async (ev) => {
        ev.preventDefault();
        setIsLoading(true);
    
        const cleanEmail = (email || "").trim().toLowerCase();
        
        if (!cleanEmail) {
            setAlert({ message: "Veuillez saisir votre email.", type: "danger" });
            setIsLoading(false);
            return;
        }

        if (!executeRecaptcha) {
            setAlert({ message: "Recaptcha pas encore chargé.", type: "danger" });
            setIsLoading(false);
            return;
        }

        try {

            console.log("kindy");
            const recaptchaToken = await executeRecaptcha("forgot_password");

            const captchaRes = await verifyCaptchaV3({ token: recaptchaToken });

            if (!captchaRes?.data?.success) {
                setAlert({
                    message: "Une activité suspecte a été détectée, veuillez réessayer.",
                    type: "danger",
                });
                setIsLoading(false);
                return;
            }

            const res = await AuthServices.forgotPassword({ email: cleanEmail });

            setAlert({
                message:
                    res?.data?.message ||
                    "Si un compte existe avec cet email, un message de réinitialisation a été envoyé.",
                type: "success",
            });

            setIsLoading(false);

            setEmail("");

        } catch (error) {
            const msg =
                error?.response?.data?.message ||
                "Erreur lors de la demande. Veuillez réessayer.";

            setAlert({ message: msg, type: "danger" });
            setIsLoading(false);
        }
    };


    return (
        <>
            {isLoading ? (
                <LoaderAuth />
            ) : (
                <div className="container pb-5 mb-5 pt-5 forgot_page">
                    <i
                        className="bi bi-x-circle login_icon_x"
                        role="button"
                        onClick={() => navigate("/connexion")}
                    ></i>

                    <div className="forgot_card">
                        <div className="forgot_header">
                            <h1>Mot de passe oublié</h1>
                            <p>
                                Entrez votre email. Nous vous enverrons un lien (ou un code) pour
                                réinitialiser votre mot de passe.
                            </p>
                        </div>

                        <form className="forgot_form" onSubmit={handleSubmit}>
                            <input
                                type="email"
                                placeholder="Email"
                                className="signin_input_text"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />

                            <button type="submit" className="login_validate">
                                ENVOYER
                            </button>

                            <div className="forgot_footer">
                                <span
                                    role="button"
                                    className="forgot_back"
                                    onClick={() => navigate("/connexion")}
                                >
                                    ← Retour à la connexion
                                </span>
                            </div>
                        </form>
                    </div>
                </div>

            )}
        </>
    );
};

export default ForgotPassword;
